export const useHeaderRect = () => {
  const layoutHeader = document.querySelector('[data-layout-header]');
  const getLayoutHeaderHeight = () => {
    if (!layoutHeader) return 0;
    const { top, height } = layoutHeader.getBoundingClientRect();
    return Math.max(0, top) + height;
  };
  const getLayoutHeaderBottom = () => {
    if (!layoutHeader) return 0;
    return layoutHeader.getBoundingClientRect().bottom;
  };

  return { getLayoutHeaderHeight, getLayoutHeaderBottom };
};
